import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import cameraLoader from "../../camera-loading.json";

const CameraLoadingOverlay = ({ isVisible, containerStyle = {} }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let timer;
    if (isVisible) {
      timer = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 1000);
    } else {
      setElapsedTime(0); // Reset timer when not visible
    }
    return () => clearInterval(timer);
  }, [isVisible]);

  // Message based on elapsed time
  const getStatusMessage = () => {
    if (elapsedTime < 2) return "Camera is starting...";
    if (elapsedTime < 4) return "Almost there...";
    return "Taking longer than usual...";
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(1, 0, 0, 0.95)",
      zIndex: 10,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      ...containerStyle
    }}>
      <div style={{ textAlign: "center" }}>
        <Lottie animationData={cameraLoader} loop style={{ width: 60, height: 60, margin: "0 auto" }} />
        <p style={{ marginTop: 16, fontSize: 14, color: "#FFFFFF", fontWeight: 500, textAlign: "center" }}>
          {getStatusMessage()}
        </p>
      </div>
    </div>
  );
};

export default CameraLoadingOverlay;
